import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { StaffRegisterManualEmailRequest } from "./StaffRegisterManualEmailRequest";
import { StaffImportPreviewRequest } from "./StaffImportPreviewRequest";
import { StaffDigitalIDImportPreviewRequest } from "./StaffDigitalIDImportPreviewRequest";
import { ManualStaffSelectRequest } from "./ManualStaffSelectRequest";
import { StaffDIDExportRequest } from "./StaffDIDExportRequest";
import { CheckValidActivationsRequest } from "./CheckValidActivationsRequest";

@Injectable()
export class DataService_Staff_DigitalID {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	StaffTypeSelectList(IncludeInstructor) {
		var postResult$ = new Subject();
		var url = "Staff/StaffTypeSelectList?IncludeInstructor=" + IncludeInstructor;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StaffCourseSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "DigitalID/StaffCourseSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RegisterManualStaffSelectList(parms: ManualStaffSelectRequest) {
		var postResult$ = new Subject();
		var url = "DigitalID/RegisterManualStaffSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RegisterEmail(parms: StaffRegisterManualEmailRequest) {
		var postResult$ = new Subject();
		var url = "DigitalID/RegisterEmail";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EmailLogInfoSelectList(StartDate, EndDate) {
		var postResult$ = new Subject();
		var url = "DigitalID/StaffEmailLogInfoSelectList?StartDate=" + StartDate + "&EndDate=" + EndDate;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ExportFormatOptionSelectList() {
		var postResult$ = new Subject();
		var url = "DigitalID/ExportFormatOptionSelectList?";
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ExportSelectList(parms: StaffDIDExportRequest) {
		var postResult$ = new Subject();
		var url = "DigitalID/StaffExportSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadImportPreviewData(parms: StaffImportPreviewRequest) {
		var postResult$ = new Subject();
		var url = "DigitalID/StaffLoadImportPreviewData";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadImportPreviewAll(parms: StaffDigitalIDImportPreviewRequest) {
		var postResult$ = new Subject();
		var url = "DigitalID/StaffLoadImportPreviewAll";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EmailCheckValidActivations(parms: CheckValidActivationsRequest) {
		var postResult$ = new Subject();
		var url = "DigitalID/EmailCheckValidActivations";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
